import * as yup from 'yup';

export default yup.object().shape({
  _id: yup.string().required(),
  name: yup.string().trim(),
  description: yup.string().trim(),
  isPublic: yup.boolean(),
  isEditable: yup.boolean(),
});
